import {Locale} from '../../../api/types/carvagoApiTypes';
import {isLocale} from './isLocale';

/**
 * Carvago API expects the locale in upper case (`X-Locale: DE`), while the app language is lower case (`de`).
 * A regional value (`fr-FR`) is reduced to its base language. Languages Carvago does not translate
 * are omitted, so the API falls back to English.
 */
export const getCarvagoLocale = (language: string | undefined): Locale | undefined => {
  const locale = language?.split('-')[0]?.toUpperCase();

  return isLocale(locale) ? locale : undefined;
};
